export function sliceString (string, maxLength = 30) {
  return string.length < maxLength ? string : `${string.slice(0, maxLength)}...`
}
